let productData = [
    {id:1, title: "iPhone 6", desc: "Experience the extraordinary with iPhone: Superb speed, professional camera, and sleek design. Embrace the future and push the boundaries of creativity with iPhone.", price: 399},
    {id:2, title: "Oculus Rift", desc: "Step into a world beyond your imagination with Oculus Rift! Immerse yourself in stunning virtual reality experiences and unlock the possibilities of a new dimension.", price: 349},
    {id:3, title: "GoPro Hero 6", desc: "Capture every adventure with GoPro - the ultimate action camera for adrenaline junkies!", price: 229},
]

export default productData
